import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40730235&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40730235",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40730235')) {
      api.createRecord('40730235', component.options)
    } else {
      api.reload('40730235', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40730235&scoped=true", function () {
      api.rerender('40730235', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectTable/index.vue"
export default component.exports